import { IContextOptionResponse } from "../interfaces/context-options-response"
import { api } from "../../api"
import { makeContextOptionsApiRoutes } from "../api/endpoints"

const contextOptionsApiRoutes = makeContextOptionsApiRoutes()

export const contextOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchContextOptions: builder.query<IContextOptionResponse[], string>({
      query: (userId: string) => contextOptionsApiRoutes.contextOptions(userId),
      providesTags: ["ContextOptions"],
    }),
  }),
})

export const { useFetchContextOptionsQuery } = contextOptionsApi
